

			<app-form-input [parentForm]="parentForm" [disabled]="disabled"
				[value]="initial.adressesComplt.envoi?.conditionsRemise" [label]="step11.getconditionsremise"
				[type]="'text'" [rule]="'minSize_1|maxSize_2000'" [name]="getUidEnvoi()+'_SepAtt_conditionsRemise'">
			</app-form-input>

			<app-form-input id="step11" [parentForm]="parentForm" [disabled]="disabled"
				[value]="initial.renseignements.idMarche" [label]="step11.getidmarche" [type]="'text'"
				[rule]="'minSize_2|maxSize_32'" [errorMessage]="{'minLength' : 'ctr_57'}"
				[name]="getUidRenseignements()+'_SepAtt_idMarche'">
			</app-form-input>

			<app-infos-sup [uid]="getUid()" [parentForm]="parentForm" [disabled]="disabled"
				[infosSup]="initial.infosSup"></app-infos-sup>

			<app-form-input [parentForm]="parentForm" [disabled]="disabled" [value]="initial.renseignements.rensgComplt"
				[label]="step11.getrensgcomplt" [type]="'text'" [rule]="'minSize_5|maxSize_32768'"
				[errorMessage]="{'minLength' : 'ctr_65'}" [name]="getUidRenseignements()+'_SepAtt_rensgComplt'">
			</app-form-input>
	